import { Box, Typography } from '@mui/material';

type Props = {
  label: string;
  values: React.ReactNode;
};

export default function SectionComponentRow({ label, values }: Props) {
  return (
    <Box className="section-row" width="100%">
      {label && (
        <Typography variant="overline" component="p">
          {label}
        </Typography>
      )}
      {values}
    </Box>
  );
}
